import * as moment from "moment";
import {JobEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import JobEvent, {JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";

/**
 * Job marked as paid event.
 */
export default class JobMarkedAsPaidEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobMarkedAsPaidEvent {
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobMarkedAsPaidEvent(json.id, json.jobId, JobEventTypeEnum.MarkedAsPaid, entity,
			moment(json.createdAt), json.referenceNumber);
	}

	getIcon() {
		return Icon.Finance;
	}

	getActivityType() {
		return "PAYMENT";
	}

	getActivityMessage(): string {
		return `Job Marked As Paid`;
	}
}
